"use client"

import { useState, useEffect } from "react"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import DataTable from "examples/Tables/DataTable"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material/styles"
import { ToastContainer, toast } from "react-toastify"
import { Stack, CircularProgress } from "@mui/material"
import InputBase from "@mui/material/InputBase"
import Paper from "@mui/material/Paper"
import SearchIcon from "@mui/icons-material/Search"
import Papa from "papaparse"
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner"
import MDBadge from "components/MDBadge"
import { useNavigate } from "react-router-dom"
import VisibilityIcon from "@mui/icons-material/Visibility"
import colors from "assets/theme/base/colors"
import "../campus/Campus.css"
import Select from "react-select"
import nodata from "assets/images/nodata.png"
const { info } = colors
const BASE_URL = process.env.REACT_APP_BASE_URL
const token = sessionStorage.getItem("token")
import { hasAdmissionPermission } from "hooks/permissions"
const ITEM_HEIGHT = 50
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

function ReviewApplications() {
  const theme = useTheme()
  const navigate = useNavigate()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
  const [maxWidth, setMaxWidth] = useState("xl")
  const userDepartment = JSON.parse(sessionStorage.getItem("department_id"))
  const [genderFilter, setGenderFilter] = useState("")
  const [nationalityFilter, setNationalityFilter] = useState("")
  const nationalities = ["Pakistani", "Overseas"]
  const [loading, setLoading] = useState(false)
  const [disabilityFilter, setDisabilityFilter] = useState("")
  const [programLevelFilter, setProgramLevelFilter] = useState("")
  const programLevels = [
    "Undergraduate (BS Programs)",
    "Graduate (MS, M-Phil Programs)",
    "Doctorate (PhD Programs)",
    "5th Semester",
  ]

  // Session Storage
  const user = JSON.parse(sessionStorage.getItem("user"))
  const organization_id = user ? user.organization_id : null

  const [anchorEl, setAnchorEl] = useState(null)
  const [opens, setOpens] = useState(false)
  const [currentAppId, setCurrentAppId] = useState(null)

  // Variable Declarations
  const [all_applications, setAllApplications] = useState([])
  const [all_campaigns, setAllCampaigns] = useState([])
  const [all_departments, setAllDepartments] = useState([])
  const [all_programs, setAllPrograms] = useState([])
  const [all_quotas, setAllQuotas] = useState([])
  const [all_campuses, setAllCampuses] = useState([])
  const [campaign_ids, setCampaignIds] = useState([])
  const [department_ids, setDepartmentIds] = useState([])
  const [program_ids, setProgramIds] = useState([])
  const [quota_ids, setQuotaIds] = useState([])
  const [campus_ids, setCampusIds] = useState([])
  const [originalApplications, setOriginalApplications] = useState([])
  const [searchKeyword, setSearchKeyword] = useState("")
  const [applicationType, setApplicationType] = useState("")
  const [isComplete, setIsComplete] = useState("")

  // Add state for selected values to control the Select components
  const [selectedCampaigns, setSelectedCampaigns] = useState([])
  const [selectedCampuses, setSelectedCampuses] = useState([])
  const [selectedDepartments, setSelectedDepartments] = useState([])

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget)
    setOpens(true)
    setCurrentAppId(appId)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpens(false)
    setCurrentAppId(null)
  }

  const handleViewApplication = (id) => {
    window.open(`/admissions/get-applications/${id}`)
  }

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase()
    setSearchKeyword(searchTerm)

    if (!searchTerm) {
      setAllApplications(originalApplications)
      return
    }

    const filteredApplications = originalApplications.filter((app) => {
      return (
        (app.id && app.id.toString().toLowerCase().includes(searchTerm)) ||
        (app.name && app.name.toLowerCase().includes(searchTerm))
      )
    })

    setAllApplications(filteredApplications)
  }

  const handleExportCSV = () => {
    if (all_applications.length === 0) return

    // Get all unique academic types from all applications
    const getAllAcademicTypes = () => {
      const types = new Set()
      all_applications.forEach((app) => {
        if (app.academics && app.academics.length > 0) {
          app.academics.forEach((academic) => {
            if (academic.type) {
              types.add(academic.type)
            }
          })
        }
      })
      return Array.from(types).sort() // Sort for consistent column order
    }

    const academicTypes = getAllAcademicTypes()

    // Define the base headers
    const baseHeaders = [
      "Sr.No",
      "Application ID",
      "Name",
      "Father Name",
      "Gender",
      "DOB",
      "Religion",
      "City",
      "Province",
      "Emergency Contact Name",
      "Emergency Contact No",
      "Applicant CNIC",
      "Father CNIC",
      "Nationality",
      "Disability",
      "Father Occupation",
      "Father Income",
      "BZU Registration No",
      "Current Address",
      "Permanent Address",
      "Telephone No",
      "Father Phone",
      "Applicant Phone",
      "Hafiz Quran",
      "Emergency Contact Address",
      "Need Transport",
      "Campaign Name",
      "Paid Status",
      "Departments",
      "Programs",
    ]

    // Create dynamic academic headers
    const academicHeaders = []
    academicTypes.forEach((type) => {
      const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1)
      academicHeaders.push(
        `${typeCapitalized} - Year`,
        `${typeCapitalized} - Degree`,
        `${typeCapitalized} - Roll No`,
        `${typeCapitalized} - University/Board`,
        `${typeCapitalized} - Total Marks`,
        `${typeCapitalized} - Obtained Marks`,
        `${typeCapitalized} - Percentage`,
        `${typeCapitalized} - Grade`,
        `${typeCapitalized} - Division`,
        `${typeCapitalized} - Position`,
        `${typeCapitalized} - Exam Pass In`,
        `${typeCapitalized} - Major Subject`,
        `${typeCapitalized} - Elective Subject 1`,
        `${typeCapitalized} - Elective Subject 2`,
        `${typeCapitalized} - Elective Subject 3`,
        `${typeCapitalized} - Elective 1 Total Marks`,
        `${typeCapitalized} - Elective 1 Obtained Marks`,
        `${typeCapitalized} - Elective 2 Total Marks`,
        `${typeCapitalized} - Elective 2 Obtained Marks`,
        `${typeCapitalized} - Elective 3 Total Marks`,
        `${typeCapitalized} - Elective 3 Obtained Marks`,
      )
    })

    // Combine all headers
    const headers = [...baseHeaders, ...academicHeaders]

    // Helper function to get academic data by type
    const getAcademicDataByType = (academics, type) => {
      if (!academics || academics.length === 0) return null
      return academics.find((academic) => academic.type === type) || null
    }

    // Map the rows to include all necessary fields
    const data = all_applications.map((app, index) => {
      // Base data
      const baseData = {
        serial: index + 1,
        id: app.id,
        name: app.name,
        father_name: app.father_name,
        gender: app.gender,
        dob: app.dob,
        religion: app.religion,
        p_city: app.p_city,
        p_province: app.p_province,
        emergency_contact_name: app.emergency_contact_name,
        emergency_contact_no: app.emergency_contact_no,
        applicant_cnic: app.applicant_cnic,
        father_cnic: app.father_cnic,
        nationality: app.nationality,
        disability: app.disability,
        father_occupation: app.father_occupation,
        father_income: app.father_income,
        bzu_registration_no: app.bzu_registration_no,
        current_address: app.current_address,
        permanent_address: app.permanent_address,
        tel_no: app.tel_no,
        father_phone: app.father_phone,
        applicant_phone: app.applicant_phone,
        hafiz_quran: app.hafiz_quran,
        emergency_contact_address: app.emergency_contact_address,
        need_transport: app.need_transport,
        campaign_name: app.campaign_name,
        paid_status: app.paid_status == 1 ? "Paid" : "Unpaid",
        departments: app.departments,
        programs: app.programs,
      }

      // Academic data
      const academicData = {}
      academicTypes.forEach((type) => {
        const academic = getAcademicDataByType(app.academics, type)
        const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1)

        academicData[`${typeCapitalized}_Year`] = academic?.year || ""
        academicData[`${typeCapitalized}_Degree`] = academic?.degree || ""
        academicData[`${typeCapitalized}_Roll_No`] = academic?.roll_no || ""
        academicData[`${typeCapitalized}_University_Board`] = academic?.university || ""
        academicData[`${typeCapitalized}_Total_Marks`] = academic?.total_marks || ""
        academicData[`${typeCapitalized}_Obtained_Marks`] = academic?.obtain_marks || ""
        academicData[`${typeCapitalized}_Percentage`] = academic?.percentage
          ? Number.parseFloat(academic.percentage).toFixed(2) + "%"
          : ""
        academicData[`${typeCapitalized}_Grade`] = academic?.grade || ""
        academicData[`${typeCapitalized}_Division`] = academic?.division || ""
        academicData[`${typeCapitalized}_Position`] = academic?.position || ""
        academicData[`${typeCapitalized}_Exam_Pass_In`] = academic?.exam_pass_in || ""
        academicData[`${typeCapitalized}_Major_Subject`] = academic?.major_subject || ""
        academicData[`${typeCapitalized}_Elective_Subject_1`] = academic?.elective_subject_one || ""
        academicData[`${typeCapitalized}_Elective_Subject_2`] = academic?.elective_subject_two || ""
        academicData[`${typeCapitalized}_Elective_Subject_3`] = academic?.elective_subject_three || ""
        academicData[`${typeCapitalized}_Elective_1_Total_Marks`] = academic?.one_total_marks || ""
        academicData[`${typeCapitalized}_Elective_1_Obtained_Marks`] = academic?.one_obtain_marks || ""
        academicData[`${typeCapitalized}_Elective_2_Total_Marks`] = academic?.two_total_marks || ""
        academicData[`${typeCapitalized}_Elective_2_Obtained_Marks`] = academic?.two_obtain_marks || ""
        academicData[`${typeCapitalized}_Elective_3_Total_Marks`] = academic?.three_total_marks || ""
        academicData[`${typeCapitalized}_Elective_3_Obtained_Marks`] = academic?.three_obtain_marks || ""
      })

      return { ...baseData, ...academicData }
    })

    // Convert to CSV format
    const csv = Papa.unparse([headers, ...data.map((row) => Object.values(row))])

    // Create a blob and download the CSV
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")

    // Handle different browsers
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", `Applications_with_Academics_${new Date().toISOString().split("T")[0]}.csv`)
      link.style.visibility = "hidden"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    // Show success message
    toast.success(`CSV exported successfully with ${academicTypes.length} academic types!`)
  }

  // API calls
  const fetchAllCampaigns = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
      const response = await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      const data = await response.json()
      setAllCampaigns(data.campaigns)

      // Auto-select first active campaign if userDepartment exists
      if (userDepartment && data.campaigns && data.campaigns.length > 0) {
        const activeCampaigns = data.campaigns.filter((camp) => camp.status === 1)
        if (activeCampaigns.length > 0) {
          const firstActiveCampaign = activeCampaigns[0]
          setCampaignIds([firstActiveCampaign.id])
          setSelectedCampaigns([
            {
              value: firstActiveCampaign.id,
              label: firstActiveCampaign.name,
            },
          ])
        }
      }
    } catch (error) {
      console.log("Error fetching campaigns:", error)
    }
  }

  const fetchAllCampuses = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
      const response = await fetch(BASE_URL + `/campus/get_campuses`, requestOptions)
      const data = await response.json()
      setAllCampuses(data.campuses)

      // Auto-select first campus if userDepartment exists
      if (userDepartment && data.campuses && data.campuses.length > 0) {
        const firstCampus = data.campuses[0]
        setCampusIds([firstCampus.id])
        setSelectedCampuses([
          {
            value: firstCampus.id,
            label: firstCampus.name,
          },
        ])
      }
    } catch (error) {
      console.log("Error fetching campuses:", error)
    }
  }

  const fetchDepartmentsByCampuses = async (campusIds) => {
    if (!campusIds || campusIds.length === 0) {
      setAllDepartments([])
      return
    }

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ campus_ids: campusIds }),
      }
      const response = await fetch(BASE_URL + `/department/get_departments_by_campuses`, requestOptions)
      const data = await response.json()
      setAllDepartments(data.departments)

      // Auto-select user's department if userDepartment exists
      if (userDepartment && data.departments && data.departments.length > 0) {
        const userDept = data.departments.find((dept) => dept.id === userDepartment)
        if (userDept) {
          setDepartmentIds([userDepartment])
          setSelectedDepartments([
            {
              value: userDepartment,
              label: userDept.name,
            },
          ])
        }
      }
    } catch (error) {
      console.log("Error fetching departments:", error)
    }
  }

  const fetchProgramsByDepartments = async (departmentIds) => {
    if (!departmentIds || departmentIds.length === 0) {
      setAllPrograms([])
      return
    }

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          department_ids: departmentIds,
          campaign_ids: selectedCampaigns.map((item) => item.value),
        }),
      }
      const response = await fetch(BASE_URL + `/degree/get_programs_by_departments_and_campaigns`, requestOptions)
      const data = await response.json()
      setAllPrograms(data.degrees)
    } catch (error) {
      console.log("Error fetching programs:", error)
    }
  }

  const fetchQuotas = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
      const response = await fetch(BASE_URL + `/quota/get_quotas`, requestOptions)
      const data = await response.json()
      setAllQuotas(data.quotas)
    } catch (error) {
      console.log("Error fetching quotas:", error)
    }
  }

  const getFilteredApplications = async () => {
    // Check if at least one campaign is selected
    if (!campaign_ids || campaign_ids.length === 0) {
      toast.error("Please select at least one campaign")
      return
    }

    setLoading(true)

    // Prepare filter data
    const filterData = {
      campaign_ids,
      program_ids: program_ids.length > 0 ? program_ids : null,
      quota_ids: quota_ids.length > 0 ? quota_ids : null,
      department_ids: department_ids.length > 0 ? department_ids : null,
      campus_ids: campus_ids.length > 0 ? campus_ids : null,
      nationality: nationalityFilter || null,
      disability: disabilityFilter || null,
      gender: genderFilter || null,
      application_type: applicationType || null,
      is_complete: isComplete || null,
      program_level: programLevelFilter || null,
    }

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterData),
      }

      const response = await fetch(BASE_URL + `/application/get_filtered_applications`, requestOptions)
      const result = await response.json()

      if (response.ok) {
        const applications = result.applications || []
        setAllApplications(applications)
        setOriginalApplications(applications)

        // Store application IDs in session storage if needed
        const application_ids = applications.map((app) => app.id)
        sessionStorage.setItem("applicationArray", JSON.stringify(application_ids))

        toast.success(`${result.total_count || applications.length} applications found`)
      } else {
        toast.error(result.error || "Failed to fetch applications")
      }
    } catch (error) {
      console.error("API Error:", error)
      toast.error("An error occurred while fetching applications")
    } finally {
      setLoading(false)
    }
  }

  // Table Configuration
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Application ID", accessor: "id", align: "center" },
    { Header: "Applicant Name", accessor: "applicant_name", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "center" },
    { Header: "DOB", accessor: "dob", align: "center" },
    { Header: "Applicant Phone", accessor: "applicant_phone", align: "center" },
    { Header: "Gender", accessor: "gender", align: "center" },
    { Header: "Province", accessor: "province", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Paid Status", accessor: "paid_status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ]

  const rows =
    all_applications.length > 0
      ? all_applications.map((app, index) => ({
          serial: index + 1,
          id: app.id,
          applicant_name: app.name,
          father_name: app.father_name,
          dob: app.dob,
          applicant_phone: app.applicant_phone,
          gender: app.gender,
          province: app.p_province,
          status:
            app.is_completed === 1 ? (
              <MDBox ml={-1}>
                <MDBadge badgeContent="Completed" color="success" variant="gradient" size="sm" />
              </MDBox>
            ) : (
              <MDBox ml={-1}>
                <MDBadge badgeContent="Incomplete" color="warning" variant="gradient" size="sm" />
              </MDBox>
            ),
          paid_status: app.paid_status === 1 ? "Paid" : "Unpaid",
          actions: (
            <>
              {hasAdmissionPermission("Review Applications", "READ") && (
                <IconButton onClick={() => handleViewApplication(app.id)}>
                  <VisibilityIcon style={{ color: "blue" }} />
                </IconButton>
              )}
            </>
          ),
        }))
      : [
          {
            serial: null,
            id: null,
            applicant_name: null,
            father_name: null,
            campaign_name: null,
            campus_name: null,
            department_name: null,
            degree_name: null,
            status: null,
            actions: null,
          },
        ]

  // Initial data loading
  useEffect(() => {
    // Clear previous session data
    sessionStorage.removeItem("applicationArray")

    // Load initial data
    fetchAllCampaigns()
    fetchAllCampuses()
    fetchQuotas()
  }, [])

  // Handle campus and department changes
  useEffect(() => {
    fetchDepartmentsByCampuses(campus_ids)
  }, [campus_ids])

  useEffect(() => {
    fetchProgramsByDepartments(department_ids)
  }, [department_ids])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className="mb-4">
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={2}>
                  Application Filters
                </MDTypography>
                <Grid container spacing={2}>
                  {/* First row of filters */}
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Campaigns
                    </MDTypography>
                    <Select
                      isMulti
                      name="campaign_ids"
                      options={all_campaigns.map((camp) => ({
                        value: camp.id,
                        label: camp.name,
                      }))}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Campaigns"
                      value={selectedCampaigns}
                      onChange={(selected) => {
                        setCampaignIds(selected ? selected.map((item) => item.value) : [])
                        setSelectedCampaigns(selected || [])
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Campuses
                    </MDTypography>
                    <Select
                      isMulti
                      name="campus_ids"
                      options={all_campuses.map((campus) => ({
                        value: campus.id,
                        label: campus.name,
                      }))}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Campuses"
                      value={selectedCampuses}
                      onChange={(selected) => {
                        setCampusIds(selected ? selected.map((item) => item.value) : [])
                        setSelectedCampuses(selected || [])
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Departments
                    </MDTypography>
                    <Select
                      isMulti
                      name="department_ids"
                      options={all_departments.map((dept) => ({
                        value: dept.id,
                        label: dept.name,
                      }))}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Departments"
                      value={selectedDepartments}
                      onChange={(selected) => {
                        setDepartmentIds(selected ? selected.map((item) => item.value) : [])
                        setSelectedDepartments(selected || [])
                      }}
                      isDisabled={!campus_ids || campus_ids.length === 0}
                    />
                  </Grid>

                  {/* Second row of filters */}
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Programs
                    </MDTypography>
                    <Select
                      isMulti
                      name="program_ids"
                      options={all_programs.map((program) => ({
                        value: program.id,
                        label: program.name,
                      }))}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Programs"
                      onChange={(selected) => {
                        setProgramIds(selected ? selected.map((item) => item.value) : [])
                      }}
                      isDisabled={!department_ids || department_ids.length === 0}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Quotas
                    </MDTypography>
                    <Select
                      isMulti
                      name="quota_ids"
                      options={all_quotas.map((quota) => ({
                        value: quota.id,
                        label: quota.name,
                      }))}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Quotas"
                      onChange={(selected) => {
                        setQuotaIds(selected ? selected.map((item) => item.value) : [])
                      }}
                    />
                  </Grid>
                  {/* Third row of filters */}
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Gender
                    </MDTypography>
                    <Select
                      name="gender"
                      options={[
                        { value: "Male", label: "Male" },
                        { value: "Female", label: "Female" },
                        { value: "Other", label: "Other" },
                      ]}
                      className="basic-select"
                      classNamePrefix="select"
                      placeholder="Select Gender"
                      onChange={(selected) => {
                        setGenderFilter(selected?.value || "")
                      }}
                      isClearable
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Nationality
                    </MDTypography>
                    <Select
                      name="nationality"
                      options={nationalities.map((nat) => ({
                        value: nat,
                        label: nat,
                      }))}
                      className="basic-select"
                      classNamePrefix="select"
                      placeholder="Select Nationality"
                      onChange={(selected) => {
                        setNationalityFilter(selected?.value || "")
                      }}
                      isClearable
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Disability
                    </MDTypography>
                    <Select
                      name="disability"
                      options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      className="basic-select"
                      classNamePrefix="select"
                      placeholder="Select Disability Status"
                      onChange={(selected) => {
                        setDisabilityFilter(selected?.value || "")
                      }}
                      isClearable
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Completion Status
                    </MDTypography>
                    <Select
                      name="is_complete"
                      options={[
                        { value: "1", label: "Complete" },
                        { value: "0", label: "Incomplete" },
                      ]}
                      className="basic-select"
                      classNamePrefix="select"
                      placeholder="Select Status"
                      onChange={(selected) => {
                        setIsComplete(selected?.value || "")
                      }}
                      isClearable
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                      Program Level
                    </MDTypography>
                    <Select
                      name="program_level"
                      options={programLevels.map((level) => ({
                        value: level,
                        label: level,
                      }))}
                      className="basic-select"
                      classNamePrefix="select"
                      placeholder="Select Program Level"
                      onChange={(selected) => {
                        setProgramLevelFilter(selected?.value || "")
                      }}
                      isClearable
                    />
                  </Grid>

                  {/* Action Buttons */}
                  <Grid item xs={12} display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={getFilteredApplications}
                      disabled={loading}
                      sx={{ mt: 2 }}
                      style={{ color: "white" }}
                    >
                      {loading ? <CircularProgress size={24} color="inherit" /> : "Fetch Applications"}
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>

            <Card>
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <MDTypography variant="h6" fontWeight="medium">
                    Applications
                  </MDTypography>

                  <Stack direction="row" spacing={2}>
                    <Paper component="form" className="search-paper">
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search applications" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon className="search-icon" />
                    </Paper>
                    {hasAdmissionPermission("Review Applications", "EXPORT CSV") && (
                      <Button
                        variant="contained"
                        color="primary"
                        endIcon={<DocumentScannerIcon />}
                        onClick={handleExportCSV}
                        style={{ color: "white" }}
                      >
                        Export CSV
                      </Button>
                    )}
                  </Stack>
                </Stack>
              </MDBox>

              <MDBox pt={3} pb={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" p={5}>
                    <CircularProgress />
                  </MDBox>
                ) : all_applications && all_applications.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <MDBox display="flex" flexDirection="column" alignItems="center" p={5}>
                    <img
                      src={nodata || "/placeholder.svg"}
                      style={{
                        width: "20%",
                        height: "20%",
                      }}
                      alt="No Data"
                    />
                    <MDTypography variant="body1" mt={2}>
                      No applications found. Please adjust your filters and try again.
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  )
}

export default ReviewApplications
